import { toAbsoluteUrl } from "../../../../_metronic/helpers";

const getMaxPeople = (exp: {
    guestCapacityAdults?: string;
    guestCapacityChildren?: string;
    guestCapacityInfants?: string;
}): number => {
    if(!exp) return 0;
    const fields = [
        exp.guestCapacityAdults,
        exp.guestCapacityChildren,
        exp.guestCapacityInfants,
    ];
    let total = 0;
    for (const field of fields) {
        if (!field) continue; // null, undefined, ''
        if (!field.includes("-")) continue;

        const [, maxStr] = field.split("-");
        const max = Number(maxStr || 0);

        if (!isNaN(max)) {
            total += max;
        }
    }
    return total;
}

// UAT-211: the preview short description is plain text (string | null), rendered as text.
// Treat null / undefined / '' / whitespace-only as empty so the description block can be hidden
// instead of showing a "Pending information" placeholder or a blank paragraph.
const hasDescriptionText = (description?: string | null): boolean =>
    !!description && description.trim().length > 0;

export { getMaxPeople, hasDescriptionText }